import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/less_than_black.svg'
import _imports_1 from '@/assets/images/delete_FILL.svg'


const _hoisted_1 = { class: "project-management-view-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_3 = { class: "project-management-view-title-text h5" }
const _hoisted_4 = { class: "project-management-project-element-block" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_project_delete_popoup = _resolveComponent("project-delete-popoup")!
  const _component_tooltip = _resolveComponent("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showDeleteWarning)
      ? (_openBlock(), _createBlock(_component_project_delete_popoup, {
          key: 0,
          warningText: _ctx.projectManagementWarningText,
          confirmDeleteText: _ctx.projectManagementConfirmDeleteText,
          cancelDeleteText: _ctx.projectManagementCancelDeleteText,
          onDeleteObjectEmit: _ctx.deleteSelectedProject,
          onCancelDelete: _ctx.cancelDeletion
        }, null, 8, ["warningText", "confirmDeleteText", "cancelDeleteText", "onDeleteObjectEmit", "onCancelDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: "project-management-view-back-button small-text-grey",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.leavePage()))
        }, [
          _hoisted_2,
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("component-new-task-view.back")), 1)
        ]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("local-task-component-locales.manage-project")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.taUserProjects, (project, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", {
              class: "project-management-project-element default-text",
              onClick: ($event: any) => (_ctx.editProject(project))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["project-color", project.project_color])
              }, null, 2),
              _createElementVNode("div", null, _toDisplayString(project.project_name), 1),
              _createVNode(_component_tooltip, {
                onClick: _withModifiers(($event: any) => (_ctx.deleteProject(project.ID)), ["stop"]),
                class: "delete-tooltip",
                text: _ctx.deleteTooltipText,
                positionFromTop: 'small'
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick", "text"])
            ], 8, _hoisted_5)
          ]))
        }), 128))
      ])
    ])
  ]))
}